import { render, staticRenderFns } from "./FramePage.vue?vue&type=template&id=63763162&scoped=true&"
import script from "./FramePage.vue?vue&type=script&lang=js&"
export * from "./FramePage.vue?vue&type=script&lang=js&"
import style0 from "./FramePage.vue?vue&type=style&index=0&id=63763162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63763162",
  null
  
)

export default component.exports